import { render, staticRenderFns } from "./HomeTabs.vue?vue&type=template&id=72372b1c&scoped=true&"
import script from "./HomeTabs.vue?vue&type=script&lang=js&"
export * from "./HomeTabs.vue?vue&type=script&lang=js&"
import style0 from "./HomeTabs.vue?vue&type=style&index=0&id=72372b1c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72372b1c",
  null
  
)

export default component.exports